// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GLP-I","content":"styles_content__3nMoR","row":"styles_row__LfIs7","footer":"styles_footer__2BN6Q","phraseLength":"styles_phraseLength__1v3S5"};